<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>编辑客户</h4>
        </div>
        <div class="main-bd mg20">
            <el-row>
            <el-col :span="12">
                <SubForm v-if="customer.id > 0" :model="customer" @submit="submitForm" :key="sub_form_key"></SubForm>
            </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import CustomerService from "~/services/customer";
import CustomerStdService from "~/services/CustomerStd";
import SubForm from "~/views/customer-std/form.vue";

export default {
    components: {
        SubForm
    },

    data() {
        return {
            customer: {},
            sub_form_key: 0,
        };
    },

    created() {
        this.getCustomerInfo(this.$route.query["id"]);
    },

    methods: {
        getCustomerInfo(customerId) {
            if (parseInt(customerId < 1)) {
                return false;
            }
            CustomerService.getInfo(customerId).then(res => {
                if (res.code != 0) return;
                //此处为了兼容el-checkbox-group控件默认选中
                let item = res.data;
                this.customer.stages = [];
                item.school_type = item.school_type > 0 ? item.school_type : '';
                item.corp_ids = item.corp.map(item => item.corp_id);
                item.tag_ids = item.tag.map(item => item.tag_id);
                item.auth_site_ids = item.auth_site.map(item => item.tag_id);
                if (item.is_grade_school == '1') {
                    this.customer.stages.push('1');
                }
                if (item.is_middle_school == '1') {
                    this.customer.stages.push('2');
                }

                if (item.is_high_school == '1') {
                    this.customer.stages.push('3');
                }
                if (item.is_vsh_school == '1') {
                    this.customer.stages.push('4');
                }
                item.type = parseInt(item.type);
                
                this.customer = Object.assign({}, this.customer, item)
                this.sub_form_key ++;
            })
        },

        submitForm(customer,reset_form_callback) {
	        if (this.Acs('/customer-std/update') == true) {
		        CustomerStdService.update(customer).then(res => {
			        if (res.code == 0) {
				        this.$message({
					        message:'修改成功',
					        type:'success'
				        });
				        // this.getCustomerInfo(this.$route.query["id"]);
                        this.$router.push({ path: "/customer-std/index"});
			        }
		        })
	        }
        }
    }

};
</script>


// WEBPACK FOOTER //
// src/views/customer-std/update.vue